import React from 'react';

import { useBotPrice } from '@/hooks/useBotPrice';
import { useBuildInfo } from '@/hooks/useBuildInfo';
import { useSwitchEvmChainOnTokenChange } from '@/hooks/useSwitchEvmChainOnTokenChange';
import { useTokenUsdPrices } from '@/hooks/useTokenUsdPrices';

import { GoogleTagManager } from './GoogleTagManager';

/**
 * Use this component to fetch/hydrate global data
 */
const Globals: React.FC = () => {
  useTokenUsdPrices();
  useSwitchEvmChainOnTokenChange();
  useBotPrice();
  useBuildInfo();

  return (
    <>
      <GoogleTagManager />
    </>
  );
};

export default Globals;
